module.exports = __webpack_public_path__ + "media/theme/top_accordion_PC_3_open-54314fe5.png";